import { Global } from '@emotion/react';
import { ModalProvider } from '@features/ui-layout/components/Modal/ModalProvider';
import GlobalStyle from '@features/ui-layout/styles/globalStyle';
import theme from '@features/ui-layout/styles/theme';
import { CssVarsProvider } from '@mui/joy';
import { GoogleAnalytics } from '@next/third-parties/google';
import { Provider, ErrorBoundary } from '@rollbar/react';
import i18nConfig from '@root/next-i18next.config';
import config from '@root/src/config';
import { ReactQueryConfig } from '@root/src/services/api/reactQueryConfig';
import { NextPageWithLayout } from '@root/src/utils/types/NextPageWithLayout';
import { QueryClientProvider } from '@tanstack/react-query';
import { AppProps } from 'next/app';
import { useRouter } from 'next/navigation';
import { appWithTranslation, useTranslation } from 'next-i18next';
import { useState } from 'react';

import 'react-toastify/dist/ReactToastify.css';

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout;
};

if (config.rollbar.active) {
  // eslint-disable-next-line global-require
  require('@services/rollbar');
}

const MyApp = ({ Component, ...pageProps }: AppPropsWithLayout) => {
  const router = useRouter();
  const { t } = useTranslation();
  const [queryClient] = useState(() => ReactQueryConfig(router, t));

  const appTree = (
    <QueryClientProvider client={queryClient}>
      <Global styles={GlobalStyle} />
      <CssVarsProvider theme={theme}>
        <ModalProvider>
          <Component {...pageProps} />
          <GoogleAnalytics gaId="G-5ZJBZLKBQF" />
          {/* <ToastContainer /> */}
        </ModalProvider>
      </CssVarsProvider>
    </QueryClientProvider>
  );

  return config.rollbarActive ? (
    <Provider config={config.rollbar}>
      <ErrorBoundary>{appTree}</ErrorBoundary>
    </Provider>
  ) : (
    appTree
  );
};

export default appWithTranslation(MyApp, i18nConfig);
